import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
  selector: 'app-overview-list-container',
  templateUrl: './overview-list-container.component.html',
  styleUrls: ['./overview-list-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewListContainerComponent {
  /**
   * Receives a offer object
   */
  @Input() offer = {} as ReplacementOffer;
}
